// Helper functions for extracting dates and event IDs from WordPress data

export const extractUniqueDatesWithEventIDs = (event) => {
  if (!event || !event.children || !Array.isArray(event.children)) {
    return [];
  }

  const dates = new Map();
  
  event.children.forEach(child => {
    if (child.date && child.event_id) {
      if (!dates.has(child.date)) {
        dates.set(child.date, {
          date: child.date,
          event_id: child.event_id,
          title: child.title || `Day ${child.date}`
        });
      }
    }
  });

  return Array.from(dates.values()).sort((a, b) => new Date(a.date) - new Date(a.date));
};

// New function specifically for WordPress child events
export const extractWordPressChildEventDates = (childEvents) => {
  if (!Array.isArray(childEvents)) {
    return [];
  }

  const dates = new Map();
  
  childEvents.forEach(child => {
    if (child.start_date && child.ID) {
      // Convert Unix timestamp to readable date
      const date = new Date(parseInt(child.start_date) * 1000);
      const dateString = `${date.getDate().toString().padStart(2, '0')}.${(date.getMonth() + 1).toString().padStart(2, '0')}.${date.getFullYear()}`; // DD.MM.YYYY format
      
      if (!dates.has(dateString)) {
        dates.set(dateString, {
          date: dateString,
          event_id: child.ID,
          title: child.post_title || `Session on ${dateString}`,
          sessions: [child] // Store the actual session data
        });
      } else {
        // If date already exists, add this session to the existing date
        dates.get(dateString).sessions.push(child);
      }
    }
  });

  return Array.from(dates.values()).sort((a, b) => new Date(a.date) - new Date(b.date));
};

// New function specifically for Faicon sessions
export const extractFaiconSessionDates = (sessions) => {
  if (!Array.isArray(sessions)) {
    return [];
  }

  const dates = new Map();
  
  sessions.forEach(session => {
    if (session.start_date && session.id) {
      // Convert ISO date string to readable date
      const date = new Date(session.start_date);
      const dateString = `${date.getDate().toString().padStart(2, '0')}.${(date.getMonth() + 1).toString().padStart(2, '0')}.${date.getFullYear()}`; // DD.MM.YYYY format
      
      if (!dates.has(dateString)) {
        dates.set(dateString, {
          date: dateString,
          event_id: session.id,
          title: session.name || `Session on ${dateString}`,
          sessions: [session] // Store the actual session data
        });
      } else {
        // If date already exists, add this session to the existing date
        dates.get(dateString).sessions.push(session);
      }
    }
  });

  return Array.from(dates.values()).sort((a, b) => new Date(a.date) - new Date(b.date));
};

export const extractEventDates = (events) => {
  if (!Array.isArray(events)) {
    return [];
  }

  const allDates = new Set();
  
  events.forEach(event => {
    if (event.children && Array.isArray(event.children)) {
      event.children.forEach(child => {
        if (child.date) {
          allDates.add(child.date);
        }
      });
    }
  });

  return Array.from(allDates).sort((a, b) => new Date(a) - new Date(b));
};

export const formatEventData = (event) => {
  if (!event) return null;

  return {
    id: event.ID,
    title: event.post_title,
    slug: event.post_name,
    children: event.children || [],
    dates: extractEventDates([event])
  };
};
